import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {MinStringLengthValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateMinStringLength = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
): string | null => {
  if (
    !ValidationUtils.isValidationRule<MinStringLengthValidationRule>(rule, StatisticItemValidationType.MinStringLength)
  ) {
    return null;
  }

  const statisticValue = statistic.value;
  const ruleValue = rule.value;

  if (ValidationUtils.isInvalidStringValue(statisticValue)) {
    // логируем некорректное строковое значение
    const error = FrontendError.createInvalidStringValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (ruleValue !== 0 && statisticValue.length < ruleValue) {
    // логируем очень короткое значение
    const error = FrontendError.createShortStringValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  }

  return statisticValue;
};
